<footer>
  <div class="footer-content pt-3">
    <div class="container">
      <div class="footer-top-content">
        @if (logoContent) {
          <div class="footer-logo">
            <img [src]="logoContent.content">
          </div>
        }
        <div>
          @for (link of links; track link) {
            <a class="footer-link" (click)="openLink(link)">{{link.title}}</a>
          }
        </div>
      </div>
    </div>
  </div>
</footer>
